import { useState } from 'react';
import { CheckCircle, Mail } from 'lucide-react';
import { Button } from '../ui/button';

export default function EmailCaptureForm({ checkId }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/capture-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ check_id: checkId, email }),
      });
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      setSubmitted(true);
    } catch (err) {
      console.error('Email capture failed:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="bg-[#F8F9FA] border border-[#27AE60]/30 rounded-xl p-6 text-center">
        <CheckCircle className="text-[#27AE60] mx-auto mb-2" size={28} />
        <p className="text-[#2C3E50] font-medium">
          Report sent! Check your inbox.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-[#F8F9FA] rounded-xl p-6">
      <h3 className="font-['Montserrat'] font-bold text-[#2C3E50] mb-1">
        Want the detailed technical report?
      </h3>
      <p className="text-sm text-[#64748B] mb-4">
        Get implementation guidance and priority recommendations.
      </p>
      <form onSubmit={handleSubmit} className="flex gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 px-4 py-2 border border-slate-200 rounded-lg text-[#2C3E50] placeholder-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#3498DB] focus:border-transparent transition-all duration-200"
          required
          disabled={loading}
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-[#3498DB] hover:bg-[#2980B9] text-white shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]"
        >
          <Mail size={16} className="mr-2" />
          {loading ? 'Sending…' : 'Send Report'}
        </Button>
      </form>
      {error && (
        <p className="mt-2 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}
